export enum RemoteCapabilityEnum {
  CAPABLE = 'CAPABLE',
  NOT_CAPABLE = 'NOT_CAPABLE',
}
